module.exports = __webpack_public_path__ + "img/u.414d632a.svg";